// WHATSAPP BİLDİRİMLERİ — bütün modüllerin gönderim kaydı, inşaat günlük rapor
// hatırlatması ("Şimdi hatırlat") ve zamanlama/link süresi ayarları.
// Bağlantı ayarları (token vb.) burada DEĞİL: Admin Paneli → Entegrasyonlar.
import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';
import { useAuth } from '@/contexts/AuthContext';
import { usePageTitle } from '@/hooks/usePageTitle';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { MessageCircle, RefreshCw, BellRing, AlertTriangle, Settings2, ArrowDownLeft } from 'lucide-react';
import { toast } from 'sonner';
import { DurumRozeti, DURUM } from '@/components/WhatsAppGonder';
import { isModuleEnabledFor } from '@/lib/modules';

const bugun = () => new Date(Date.now() + 3 * 3600 * 1000).toISOString().slice(0, 10);
const zaman = (iso) => (iso ? new Date(iso).toLocaleString('tr-TR', {
  day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }) : '');
const secim = 'h-9 rounded-md border border-[#d0c4b0] bg-white px-2 text-sm';

function Gonderimler({ moduller }) {
  const [liste, setListe] = useState([]);
  const [f, setF] = useState({ modul: '', durum: '', yon: '', bas: '', bit: '', q: '' });
  const [yukleniyor, setYukleniyor] = useState(false);

  const getir = useCallback(async () => {
    setYukleniyor(true);
    try {
      const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
      const r = await api.get('/whatsapp/mesajlar', { params });
      setListe(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Liste alınamadı'); }
    setYukleniyor(false);
  }, [f]);
  useEffect(() => { getir(); }, [getir]);

  const ayarla = (k) => (e) => setF(p => ({ ...p, [k]: e.target.value }));

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-end gap-2">
        <select value={f.modul} onChange={ayarla('modul')} className={secim} data-testid="wa-suzgec-modul">
          <option value="">Tüm modüller</option>
          {Object.entries(moduller).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <select value={f.durum} onChange={ayarla('durum')} className={secim} data-testid="wa-suzgec-durum">
          <option value="">Tüm durumlar</option>
          {Object.entries(DURUM).map(([k, v]) => <option key={k} value={k}>{v.etiket}</option>)}
        </select>
        <select value={f.yon} onChange={ayarla('yon')} className={secim}>
          <option value="">Giden + gelen</option>
          <option value="giden">Giden</option>
          <option value="gelen">Gelen (cevaplar)</option>
        </select>
        <Input type="date" value={f.bas} onChange={ayarla('bas')} className="w-36 h-9 bg-white border-[#d0c4b0]" />
        <Input type="date" value={f.bit} onChange={ayarla('bit')} className="w-36 h-9 bg-white border-[#d0c4b0]" />
        <Input value={f.q} onChange={ayarla('q')} placeholder="Alıcı, numara, konu…"
          className="w-48 h-9 bg-white border-[#d0c4b0]" />
        <Button size="sm" variant="outline" onClick={getir} disabled={yukleniyor} className="border-[#d0c4b0] h-9">
          <RefreshCw size={14} className="mr-1" /> Yenile
        </Button>
      </div>
      <div className="erp-card overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#e8dfd0] hover:bg-[#e8dfd0]">
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Zaman</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Modül</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Alıcı</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Mesaj</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Durum</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Gönderen</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {liste.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center text-sm text-[#8a7e70] py-8">Kayıt yok</TableCell></TableRow>
            )}
            {liste.map(m => (
              <TableRow key={m.id} className="border-[#d0c4b0] align-top" data-testid={`wa-mesaj-${m.id}`}>
                <TableCell className="text-xs whitespace-nowrap">{zaman(m.created_at)}</TableCell>
                <TableCell className="text-xs">
                  {m.yon === 'gelen' && <ArrowDownLeft size={12} className="inline mr-0.5 text-[#5b4a8a]" />}
                  {moduller[m.kaynak_modul] || m.kaynak_modul || '—'}
                  {m.tetik && m.tetik !== 'manuel' && <span className="block text-[10px] text-[#8a7e70]">{m.tetik}</span>}
                </TableCell>
                <TableCell className="text-sm">
                  {m.alici_adi || '—'}
                  <span className="block font-mono text-[11px] text-[#8a7e70]">
                    {m.alici_numara ? `+${m.alici_numara}` : m.alici_telefon_ham || ''}
                  </span>
                </TableCell>
                <TableCell className="text-xs max-w-[22rem]">
                  {m.yon === 'gelen' ? <span className="italic">“{m.metin}”</span> : (
                    <>
                      <b>{m.parametreler?.konu}</b>
                      <span className="block text-[#5c554b] line-clamp-2">{m.parametreler?.aciklama}</span>
                      {m.link_yolu && <span className="block font-mono text-[10px] text-[#a3968a]">/{m.link_yolu}</span>}
                    </>
                  )}
                </TableCell>
                <TableCell className="text-xs">
                  <DurumRozeti durum={m.durum} />
                  {m.hata && <span className="block mt-1 text-[11px] text-[#9b3b2f] max-w-[16rem]">{m.hata}</span>}
                  {m.read_at ? <span className="block text-[10px] text-[#8a7e70]">okundu {zaman(m.read_at)}</span>
                    : m.delivered_at ? <span className="block text-[10px] text-[#8a7e70]">iletildi {zaman(m.delivered_at)}</span> : null}
                </TableCell>
                <TableCell className="text-xs">{m.gonderen_adi || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}

function InsaatHatirlatma() {
  const [tarih, setTarih] = useState(bugun());
  const [veri, setVeri] = useState(null);
  const [onay, setOnay] = useState(false);
  const [mesgul, setMesgul] = useState(false);

  const getir = useCallback(async () => {
    try {
      const r = await api.get('/whatsapp/insaat/eksikler', { params: { tarih } });
      setVeri(r.data);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Liste alınamadı'); }
  }, [tarih]);
  useEffect(() => { getir(); }, [getir]);

  const gidecek = (veri?.eksikler || []).filter(e => !e.neden && !e.hatirlatildi);

  const hatirlat = async () => {
    setMesgul(true);
    try {
      const r = await api.post('/whatsapp/insaat/hatirlat', { tarih });
      const o = r.data;
      const parca = [o.gonderilen && `${o.gonderilen} gönderildi`, o.deneme && `${o.deneme} deneme kaydı`,
        o.onceden && `${o.onceden} zaten hatırlatılmıştı`, o.hatali && `${o.hatali} başarısız`,
        o.atlanan?.length && `${o.atlanan.length} atlandı`].filter(Boolean);
      (o.hatali ? toast.warning : toast.success)(parca.join(' · ') || 'Gönderilecek kimse yok');
      setOnay(false);
      getir();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Gönderilemedi'); }
    setMesgul(false);
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-end gap-2">
        <div>
          <p className="text-xs text-[#8a7e70] mb-1">Rapor günü</p>
          <Input type="date" value={tarih} max={bugun()} onChange={(e) => setTarih(e.target.value)}
            className="w-40 h-9 bg-white border-[#d0c4b0]" data-testid="wa-eksik-tarih" />
        </div>
        <Button onClick={() => setOnay(true)} disabled={!gidecek.length} data-testid="wa-simdi-hatirlat"
          className="h-9 bg-[#3d6e4e] text-white hover:bg-[#2d5a3c]">
          <BellRing size={14} className="mr-1" /> Şimdi hatırlat ({gidecek.length})
        </Button>
      </div>
      <p className="text-xs text-[#8a7e70]">
        Raporu girilmemiş aktif alt yükleniciler ve alt taşeronlar. "Çalışma yok" bildiren ve bağlı olduğu
        alt yüklenici onun adına satır giren alt taşeron raporlu sayılır. O gün zaten hatırlatılmış olana tekrar gönderilmez.
      </p>
      <div className="erp-card overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="bg-[#e8dfd0] hover:bg-[#e8dfd0]">
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Alt Yüklenici</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Şantiye</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Alıcı</TableHead>
              <TableHead className="text-xs uppercase font-bold text-[#1a1916]">Bugünkü hatırlatma</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {veri && veri.eksikler.length === 0 && (
              <TableRow><TableCell colSpan={4} className="text-center text-sm text-[#3d6e4e] py-8">
                Bu gün için raporu eksik alt yüklenici yok.
              </TableCell></TableRow>
            )}
            {(veri?.eksikler || []).map(e => (
              <TableRow key={e.id} className="border-[#d0c4b0]" data-testid={`wa-eksik-${e.id}`}>
                <TableCell className="text-sm font-medium">
                  {e.ad}{e.ust_adi && <span className="block text-[11px] text-[#8a7e70]">{e.ust_adi} alt taşeronu</span>}
                </TableCell>
                <TableCell className="text-sm">{e.site_adi || '—'}</TableCell>
                <TableCell className="text-sm">
                  {e.alici ? <>{e.alici.ad}<span className="block font-mono text-[11px] text-[#8a7e70]">{e.alici.telefon}</span></> : '—'}
                  {e.neden && <span className="block text-[11px] text-[#9b3b2f]">{e.neden}</span>}
                </TableCell>
                <TableCell className="text-xs">
                  {e.son_gonderim ? <><DurumRozeti durum={e.son_gonderim.durum} /> <span className="text-[#8a7e70]">{zaman(e.son_gonderim.created_at)}</span></> : '—'}
                  {e.son_gonderim && !e.hatirlatildi && <span className="block text-[10px] text-[#8a7e70]">elle gönderim — hatırlatma sayılmaz</span>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <Dialog open={onay} onOpenChange={(v) => !mesgul && setOnay(v)}>
        <DialogContent className="bg-[#faf7f2]">
          <DialogHeader>
            <DialogTitle>Şimdi hatırlat</DialogTitle>
            <DialogDescription>
              {tarih} tarihli raporu eksik {gidecek.length} firmaya WhatsApp hatırlatması gönderilecek.
            </DialogDescription>
          </DialogHeader>
          <ul className="max-h-60 overflow-y-auto text-sm space-y-1">
            {gidecek.map(e => <li key={e.id}>• {e.ad} <span className="text-[#8a7e70]">— {e.alici?.ad}, {e.alici?.telefon}</span></li>)}
          </ul>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOnay(false)} disabled={mesgul} className="border-[#d0c4b0]">Vazgeç</Button>
            <Button onClick={hatirlat} disabled={mesgul} data-testid="wa-hatirlat-onay"
              className="bg-[#3d6e4e] text-white hover:bg-[#2d5a3c]">{mesgul ? 'Gönderiliyor…' : 'Gönder'}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}

function Ayarlar({ veri, yenile, duzenleyebilir }) {
  const [h, setH] = useState(veri.hatirlatma);
  const [sureler, setSureler] = useState(veri.link_sureleri);
  const [mesgul, setMesgul] = useState(false);
  useEffect(() => { setH(veri.hatirlatma); setSureler(veri.link_sureleri); }, [veri]);

  const kaydet = async () => {
    setMesgul(true);
    try {
      await api.patch('/whatsapp/hatirlatma-ayarlari', { hatirlatma: h, link_sureleri: sureler });
      toast.success('Ayarlar kaydedildi');
      yenile();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Kaydedilemedi'); }
    setMesgul(false);
  };
  const kutu = (k, metin, alt) => (
    <label className="flex items-start gap-2 text-sm cursor-pointer">
      <input type="checkbox" className="mt-1" checked={!!h[k]} disabled={!duzenleyebilir}
        onChange={(e) => setH(p => ({ ...p, [k]: e.target.checked }))} data-testid={`wa-ayar-${k}`} />
      <span><b>{metin}</b><span className="block text-xs text-[#8a7e70]">{alt}</span></span>
    </label>
  );

  return (
    <div className="grid gap-4 lg:grid-cols-2">
      <Card className="bg-[#faf7f2] border-[#d0c4b0]">
        <CardContent className="pt-4 space-y-4">
          <p className="font-semibold text-[#1a1916]">İnşaat günlük rapor hatırlatması</p>
          {kutu('aktif', 'Otomatik hatırlatma açık', 'Her gün belirlenen saatte raporu eksik alt yüklenicilere gider. Pazar ve tatil dahil.')}
          <div className="flex items-center gap-2 pl-6">
            <span className="text-sm">Saat</span>
            <Input type="time" value={h.saat} disabled={!duzenleyebilir} onChange={(e) => setH(p => ({ ...p, saat: e.target.value }))}
              className="w-28 h-9 bg-white border-[#d0c4b0]" data-testid="wa-ayar-saat" />
          </div>
          {kutu('eskalasyon_aktif', 'Ertesi sabah şantiye şefine bildir',
            'Dünün raporu hâlâ eksikse şefe şantiye başına tek mesaj. Şef, şantiye kartında tanımlanır.')}
          <div className="flex items-center gap-2 pl-6">
            <span className="text-sm">Saat</span>
            <Input type="time" value={h.eskalasyon_saat} disabled={!duzenleyebilir}
              onChange={(e) => setH(p => ({ ...p, eskalasyon_saat: e.target.value }))}
              className="w-28 h-9 bg-white border-[#d0c4b0]" data-testid="wa-ayar-eskalasyon-saat" />
          </div>
          {veri.son_turlar?.length > 0 && (
            <div className="text-xs text-[#5c554b] space-y-0.5">
              <p className="font-semibold">Son çalışmalar</p>
              {veri.son_turlar.map((t, i) => (
                <p key={i}>{t.tarih} · {t.tur === 'hatirlatma' ? 'Hatırlatma' : 'Şefe bildirim'} · {t.durum}
                  {t.sonuc?.gonderilen != null ? ` · ${t.sonuc.gonderilen} gönderildi` : ''}
                  {t.sonuc?.deneme ? ` · ${t.sonuc.deneme} deneme` : ''}
                  {t.sonuc?.not ? ` · ${t.sonuc.not}` : ''}</p>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
      <Card className="bg-[#faf7f2] border-[#d0c4b0]">
        <CardContent className="pt-4 space-y-3">
          <p className="font-semibold text-[#1a1916]">Link süreleri</p>
          <p className="text-xs text-[#8a7e70]">WhatsApp ile giden bağlantı kaç saat açık kalsın. Boş = süresiz
            (kalıcı bağlantı iptal edilince/yenilenince kapanır).</p>
          {Object.keys(sureler).map(m => (
            <div key={m} className="flex items-center justify-between gap-2">
              <span className="text-sm">{veri.modul_adlari[m] || m}</span>
              <div className="flex items-center gap-1">
                <Input type="number" min="1" value={sureler[m] ?? ''} disabled={!duzenleyebilir}
                  placeholder="süresiz" onChange={(e) => setSureler(p => ({ ...p, [m]: e.target.value === '' ? null : Number(e.target.value) }))}
                  className="w-24 h-9 bg-white border-[#d0c4b0] text-right" data-testid={`wa-sure-${m}`} />
                <span className="text-xs text-[#8a7e70] w-8">saat</span>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
      {duzenleyebilir && (
        <div className="lg:col-span-2">
          <Button onClick={kaydet} disabled={mesgul} data-testid="wa-ayar-kaydet"
            className="bg-[#2e2d29] text-[#f5f0e8] hover:bg-[#1a1916]">Kaydet</Button>
        </div>
      )}
    </div>
  );
}

export default function WhatsAppBildirimleri() {
  usePageTitle('WhatsApp Bildirimleri');
  const { company, role, hasPermission } = useAuth();
  const [ayar, setAyar] = useState(null);
  const [baglanti, setBaglanti] = useState(null);
  const insaat = isModuleEnabledFor(company, 'insaat') && hasPermission('insaat_reports', 'view');

  const yenile = useCallback(() => {
    api.get('/whatsapp/hatirlatma-ayarlari').then(r => setAyar(r.data)).catch(() => {});
  }, []);
  useEffect(() => { yenile(); }, [yenile]);
  useEffect(() => {
    if (role === 'super_admin') api.get('/whatsapp/ayarlar').then(r => setBaglanti(r.data)).catch(() => {});
  }, [role]);

  return (
    <div data-testid="whatsapp-bildirimleri">
      <div className="mb-4">
        <h1 className="text-3xl font-bold text-[#1a1916] tracking-tight flex items-center gap-2">
          <MessageCircle size={26} className="text-[#3d6e4e]" /> WhatsApp Bildirimleri
        </h1>
        <p className="text-sm text-[#8a7e70]">Bütün modüllerin WhatsApp gönderimleri, durumları ve cevaplar.</p>
      </div>
      {baglanti && (baglanti.dry_run || baglanti.test_whitelist?.length > 0 || !baglanti.access_token_var) && (
        <p className="mb-4 text-xs text-[#7a6a2e] bg-[#7a6a2e]/10 border border-[#7a6a2e]/30 rounded-md px-3 py-2 flex gap-2">
          <AlertTriangle size={14} className="shrink-0 mt-0.5" />
          {!baglanti.access_token_var ? 'Erişim anahtarı tanımlı değil. '
            : baglanti.dry_run ? 'Deneme modu açık: mesajlar gönderilmiyor, yalnız kaydediliyor. ' : ''}
          {baglanti.test_whitelist?.length > 0 && `Test modu: yalnız ${baglanti.test_whitelist.length} test numarasına gönderiliyor. `}
          Ayar: Admin Paneli → Entegrasyonlar.
        </p>
      )}
      <Tabs defaultValue="gonderimler">
        <TabsList className="mb-4">
          <TabsTrigger value="gonderimler">Gönderimler</TabsTrigger>
          {insaat && <TabsTrigger value="insaat" data-testid="wa-sekme-insaat">İnşaat hatırlatma</TabsTrigger>}
          <TabsTrigger value="ayarlar" data-testid="wa-sekme-ayarlar"><Settings2 size={14} className="mr-1" />Ayarlar</TabsTrigger>
        </TabsList>
        <TabsContent value="gonderimler"><Gonderimler moduller={ayar?.modul_adlari || {}} /></TabsContent>
        {insaat && <TabsContent value="insaat"><InsaatHatirlatma /></TabsContent>}
        <TabsContent value="ayarlar">
          {ayar && <Ayarlar veri={ayar} yenile={yenile} duzenleyebilir={hasPermission('whatsapp', 'edit')} />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
